import { Gender } from "constant";
import { Area } from "./area";
import { BusinessType } from "./business-type";
import { Customer } from "./customer";
import { GuestType } from "./guest";
import { Media } from "./media";
import { Todo } from "./todo";

export interface Shop {
  id: number;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  code: string;
  businessCode: string; //Mã số doanh nghiệp
  name: string;
  chapterName: string; //tên chatper (dành cho khách thăm)
  description: string;
  // email: string;
  // phone: string;
  address: string;
  address1: string; //Địa chỉ chi tiết (Số nhà, tòa nhà, tầng, lầu)
  // avatar: string;
  type: ShopType;
  isAllowOrder: boolean; //cho phép book trực tiếp
  //Owner
  username: string;
  password: string;
  ownerName: string;
  ownerEmail: string;
  ownerDob: string;
  ownerPhone: string;
  ownerGender: Gender;
  ownerBornPlace: string; //Nơi sinh
  ownerAvatar: string;
  position: number; //0: thấp nhất
  isDeploying: boolean;
  isBaoChung: boolean;
  //
  open: string; //format: HH:mm
  close: string; //format: HH:mm
  workingHourJson: string; //Array object json
  shipContent: string; //Thời gian giao hàng: Nội thành Tokyo 1-2 ngày
  totalRate: number;
  totalStar: number;
  lat: number;
  long: number;
  facebook: string;
  website: string;
  zalo: string; //social zalo
  line: string; //social line
  messenger: string; //social messenger
  isLiked?: boolean;
  isBlocked: boolean;
  likes: number;
  oneSignalId: string;
  bankNumber: string;
  bankName: string;
  bankOwner: string;
  expiredSuspendAt: number;
  isSuspended: boolean; //true: bị đình chỉ
  isApproved: boolean; //true: đc duyệt
  isOpenAllDay: boolean; //true: luôn mở cửa
  approvedAt: number;
  businessArea: string; // Lĩnh vực kinh doanh
  paymentMethodJson: string; //['COD','BANK_TRANSFER']
  thumbnails: Media[];
  businessType: BusinessType;
  area: Area;
  customer: Customer; //owner
  todos: Todo[];
  workshops: Workshops[];
  guestType: GuestType;
  potentialCustomer: string; //khách hàng tiềm năng
  connectionNeed: string; //nhu cầu kết nối
  isHighlight: boolean;
  suspendNote: boolean;
  avatar: string;
}

export enum ShopType {
  Company = "COMPANY", //Default
  Retail = "RETAIL", //bán lẻ
  Booking = "BOOKING", //Đặt lịch
  BookCar = "BOOKCAR", //Đặt xe
}

export const ShopTypeTrans = {
  [ShopType.Company]: "Công ty",
  [ShopType.Retail]: "Bán lẻ",
  [ShopType.Booking]: "Đặt lịch, nhà hàng",
  [ShopType.BookCar]: "Đặt xe",
};

export interface Workshops {
  id: number;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  name: string; //Họ tên ng đăng ký
  phone: string; //SDT ng đăng ký
  bookingDate: string; //ngày đăng ký hội thảo
  isSubmitted: boolean; //true: đã điểm danh
  shop: Shop;
  submittedAt: number;
  // receptionist: Receptionist;
}
